import Vue from 'vue';
import { Module } from 'vuex';

import { Course, CoursesListState, RootState } from 'frontend/types';

const featuredCourses: Module<CoursesListState, RootState> = {
  namespaced: true,
  state: () => ({
    items: [] as Course[],
  }),
  mutations: {
    setValue(state: CoursesListState, value: Course[]): void {
      Vue.set(state, 'items', value);
    },
  },
};

export default featuredCourses;
